import { render, staticRenderFns } from "./EditNewProfession.vue?vue&type=template&id=15154023"
import script from "./EditNewProfession.vue?vue&type=script&lang=js"
export * from "./EditNewProfession.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports